import React from 'react';

import './ChatHistory.css'; 

function ChatHistory({ chat }) {
    return (
        <div className="chat-history-container">
            <div className="chat-history-title">{chat.title}</div>
        </div>
    );
}

export default ChatHistory;
